

  export const trainerCourses = {
    "Manikonda Sharat": [
      {
        id: "data-structures",
        name: "Data Structures",
        image: "/images/data-structures.jpg",
        duration: "6 weeks",
        rating: 4.8,
      },
      {
        id: "apache-spark",
        name: "Apache Spark",
        image: "/images/spark.jpg",
        duration: "4 weeks",
        rating: 4.6,
      },
    ],
    "Kanhiyalal .k": [
      {
        id: "cloud-architect",
        name: "Cloud Architect",
        image: "/images/cloud.jpg",
        duration: "8 weeks",
        rating: 4.7,
      },
    ],
    "Deepak .B": [
      {
        id:"full-stack-java",
        name: "full stack java",
        image:"/images/java.jpg",
        duration:"5 weeks",
        rating: 4,

      }
    ]
  };
  